export default __webpack_public_path__ + "static/media/iconesAquisiçõesX.96559893.png";